export default interface ISfJobApplicationLayoutInput {
	id: string;
}

// Type Guard
export function isISfJobApplicationLayoutInput(
	object: any | ISfJobApplicationLayoutInput
): object is ISfJobApplicationLayoutInput {
	return (object as ISfJobApplicationLayoutInput).id !== undefined;
}
